define.alias("ember-composable-helpers/helpers/repeat", "settings/helpers/repeat");